<template>
    <b-card no-body class="m-0">
        <b-card-header header-tag="header" role="tab" class="p-2">
            <FontAwesomeIcon :icon=icon></FontAwesomeIcon>
            <span class="ml-2 font-weight-bold">{{ title }}</span>
            <b-button size="sm" class="float-right p-1" href="#" v-b-toggle=id :pressed.sync=toggled variant="light">
                <FontAwesomeIcon v-if=toggled icon="arrow-up"></FontAwesomeIcon>
                <FontAwesomeIcon v-else icon="arrow-down"></FontAwesomeIcon>
            </b-button>
        </b-card-header>
        <b-collapse :id=id visible role="tabpanel">
<!--            <b-card-body class="p-2">-->
                <slot></slot>
<!--            </b-card-body>-->
        </b-collapse>
    </b-card>
</template>

<script>

    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

    export default {
        name: "FoldingPanel",
        props: ["id", "title", 'icon'],
        components: {FontAwesomeIcon},
        data() {
            return {
                toggled: true
            }
        }
    }
</script>

<style scoped>


</style>
